import { inject, injectable } from 'inversify-props';
import { IHttpClient, ILogger, ISettings } from '../common';
import { PagedResult, DeckSurface } from '../../models';
import { IBaseService } from '../BaseService';


export interface IDeckSurfaceService extends IBaseService<DeckSurface, number> {
	getMultiple(ids: number[]): Promise<DeckSurface[]>;
}


@injectable()
export class DeckSurfaceService implements IDeckSurfaceService {

	private cache: Promise<DeckSurface[]>;

	constructor(
		@inject('IHttpClient') private httpClient: IHttpClient,
		@inject('ILogger') private logger: ILogger,
		@inject('ISettings') private settings: ISettings) { }

	public get(id: number): Promise<DeckSurface> {
		const url = `${this.settings.baseUrl}${this.settings.deckSurfaceUrl}/${id}`;
		return this.httpClient.get<DeckSurface>(url);
	}

	public getMultiple(ids: number[]): Promise<DeckSurface[]> {
		const url = `${this.settings.baseUrl}${this.settings.deckSurfaceUrl}/multiple/${ids.join(',')}`;
		return this.httpClient.get<DeckSurface[]>(url);
	}

	public page(pageIndex: number, pageSize: number): Promise<PagedResult<DeckSurface>> {
		const url = `${this.settings.baseUrl}${this.settings.deckSurfaceUrl}/${pageIndex}/${pageSize}`;
		return this.httpClient.get<PagedResult<DeckSurface>>(url);
	}

	public list(): Promise<DeckSurface[]> {
		const url = `${this.settings.baseUrl}${this.settings.deckSurfaceUrl}`;
		if (!this.cache) { this.cache = this.httpClient.get<DeckSurface[]>(url); }
		return this.cache;
	}

	public save(model: DeckSurface): Promise<DeckSurface> {
		this.cache = null; // INVALIDATE CACHE
		const payload = {
			id: model.id,
			name: model.name,
			description: model.description,
			sortBy: (model.sortBy != null) ? parseInt(model.sortBy.toString(), null) : null,
		};

		let url = `${this.settings.baseUrl}${this.settings.deckSurfaceUrl}`;
		if (model.id !== null && model.id !== undefined) {
			url += `/${model.id}`;
			return this.httpClient.put(url, payload);
		}
		return this.httpClient.post(url, payload);
	}

	public delete(id: number): Promise<any> {
		this.cache = null; // INVALIDATE CACHE
		const url = `${this.settings.baseUrl}${this.settings.deckSurfaceUrl}/${id}`;
		return this.httpClient.delete(url);
	}

}
